__turbopack_context__.v({
  "bar": "PlpSortBar-module-scss-module__Bo5rSq__bar",
  "controls": "PlpSortBar-module-scss-module__Bo5rSq__controls",
  "favouriteStore": "PlpSortBar-module-scss-module__Bo5rSq__favouriteStore",
  "filters": "PlpSortBar-module-scss-module__Bo5rSq__filters",
  "sort": "PlpSortBar-module-scss-module__Bo5rSq__sort",
  "sortList": "PlpSortBar-module-scss-module__Bo5rSq__sortList",
  "sortListSafeAreaFix": "PlpSortBar-module-scss-module__Bo5rSq__sortListSafeAreaFix",
  "sortOption": "PlpSortBar-module-scss-module__Bo5rSq__sortOption",
  "sortOptionSelected": "PlpSortBar-module-scss-module__Bo5rSq__sortOptionSelected",
  "sortTrigger": "PlpSortBar-module-scss-module__Bo5rSq__sortTrigger",
  "stats": "PlpSortBar-module-scss-module__Bo5rSq__stats",
  "store": "PlpSortBar-module-scss-module__Bo5rSq__store",
  "storeCount": "PlpSortBar-module-scss-module__Bo5rSq__storeCount",
  "storeLabel": "PlpSortBar-module-scss-module__Bo5rSq__storeLabel",
  "storeLabelDesktop": "PlpSortBar-module-scss-module__Bo5rSq__storeLabelDesktop",
  "storeLabelMobile": "PlpSortBar-module-scss-module__Bo5rSq__storeLabelMobile",
  "storeToggle": "PlpSortBar-module-scss-module__Bo5rSq__storeToggle",
  "storeToggleSwitch": "PlpSortBar-module-scss-module__Bo5rSq__storeToggleSwitch",
});
